<template>
    <PopupRouterView :showLeftIcon="true" label="Receipt From Production Case Source Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="receiptfromproductioncasesource"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="receiptFromProductionCaseSourceInput">


        <b-card header="ReceiptFromProductionCaseSource" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="receiptFromProductionCases" optionsLabel="controlCard" optionsKey="id" label-cols-lg="12" label="Receipt From Production Case" id="fieldset-receipt-from-production-case" size="sm" :model.sync="model.receiptFromProductionCaseId"   :selected="model.receiptFromProductionCase != null ? model.receiptFromProductionCase.controlCard : ''" @input="getReceiptFromProductionCases"   :isSelectMethodExists="true" @onSelectMethod="setSelectedReceiptFromProductionCase" />
						<app-input-combobox-autocomplete :options="receiptFromProductionMaterials" optionsLabel="controlCard" optionsKey="id" label-cols-lg="12" label="Receipt From Production Material" id="fieldset-receipt-from-production-material" size="sm" :model.sync="model.receiptFromProductionMaterialId"   :selected="model.receiptFromProductionMaterial != null ? model.receiptFromProductionMaterial.controlCard : ''" @input="getReceiptFromProductionMaterials"   :isSelectMethodExists="true" @onSelectMethod="setSelectedReceiptFromProductionMaterial" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts"   :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
						<app-input-textbox id="fieldset-qty-before" label-cols-lg="12"  label="Qty Before" label-for="input-qty-before" size="sm" :model.sync="model.qtyBefore"   />
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="model.qtyAfter"   />
						<app-input-textbox id="fieldset-qty-taken" label-cols-lg="12"  label="Qty Taken" label-for="input-qty-taken" size="sm" :model.sync="model.qtyTaken"   />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ReceiptFromProductionCaseSource from '@/models/ReceiptFromProductionCaseSource/ReceiptFromProductionCaseSource';
import ReceiptFromProductionCaseSourceList from '@/models/ReceiptFromProductionCaseSource/ReceiptFromProductionCaseSourceList';
import ReceiptFromProductionCaseSourceFilter from '@/filters/ReceiptFromProductionCaseSource/ReceiptFromProductionCaseSourceFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ReceiptFromProductionCase from '@/models/ReceiptFromProduction/ReceiptFromProductionCase';
import ReceiptFromProductionCaseFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionCaseFilter';
import ReceiptFromProductionMaterial from '@/models/ReceiptFromProduction/ReceiptFromProductionMaterial';
import ReceiptFromProductionMaterialFilter from '@/filters/ReceiptFromProduction/ReceiptFromProductionMaterialFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterReceiptFromProductionCaseSource : null,
			currentReceiptFromProductionCaseSourcePage : 1,
			receiptFromProductionCaseSourcePageSize: 10,
			sortByReceiptFromProductionCaseSource: '',
			sortDescReceiptFromProductionCaseSource: '',
			receiptFromProductionCases: [],
			receiptFromProductionCases: [],
			isReceiptFromProductionCaseComboLoading: false,
			receiptFromProductionMaterials: [],
			receiptFromProductionMaterials: [],
			isReceiptFromProductionMaterialComboLoading: false,
			parts: [],
			parts: [],
			isPartComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isReceiptFromProductionCaseComboLoading: false,
			isReceiptFromProductionMaterialComboLoading: false,
			isPartComboLoading: false,
		}
	},
	methods : {
		getReceiptFromProductionCaseSource : async function(id) {
			this.isBusy = true;
			ReceiptFromProductionCaseSource.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadReceiptFromProductionCaseSource = true;
			this.filterReceiptFromProductionCaseSource.id = this.modelId;
			ReceiptFromProductionCaseSource.downloadDataDetail(this, this.filterReceiptFromProductionCaseSource).then(result => {
				this.isDownloadReceiptFromProductionCaseSource = false;
			}).catch(error => { this.isDownloadReceiptFromProductionCaseSource = false; })
		},
		getReceiptFromProductionCaseSources : async function(input) {
			let filter = new ReceiptFromProductionCaseSourceFilter();
			if (input != undefined) {
				filter.ReceiptFromProductionCase = input;
			}
			this.isReceiptFromProductionCaseSourceComboLoading = true;
			ReceiptFromProductionCaseSource.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.receiptFromProductionCaseSources = result.data
				}
				this.isReceiptFromProductionCaseSourceComboLoading = false;
			})
			.catch(error => {});
		},
		getReceiptFromProductionCases : async function(input) {
			let filter = new ReceiptFromProductionCaseFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			ReceiptFromProductionCase.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.receiptFromProductionCases = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedReceiptFromProductionCase(item) {
			if(item == undefined || item == null) {
				this.model.receiptFromProductionCaseId = null;
				this.model.receiptFromProductionCase = null;
			} else {
				this.model.receiptFromProductionCaseId = item.id;
				this.model.receiptFromProductionCase = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getReceiptFromProductionMaterials : async function(input) {
			let filter = new ReceiptFromProductionMaterialFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			ReceiptFromProductionMaterial.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.receiptFromProductionMaterials = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedReceiptFromProductionMaterial(item) {
			if(item == undefined || item == null) {
				this.model.receiptFromProductionMaterialId = null;
				this.model.receiptFromProductionMaterial = null;
			} else {
				this.model.receiptFromProductionMaterialId = item.id;
				this.model.receiptFromProductionMaterial = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.receiptFromProductionCaseSourceInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						ReceiptFromProductionCaseSource.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'receiptfromproductioncasesourceindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						ReceiptFromProductionCaseSource.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'receiptfromproductioncasesourceindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ReceiptFromProductionCaseSource.updateData(this, model, id)
					.catch((error) => {
						this.getReceiptFromProductionCaseSource(id);
					});
				}
			});
		},
		onHidden() {
			this.getReceiptFromProductionCaseSources();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterReceiptFromProductionCaseSource = new ReceiptFromProductionCaseSourceFilter();
		//this.getReceiptFromProductionCases();
		//this.getReceiptFromProductionMaterials();
		//this.getParts();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getReceiptFromProductionCaseSource(id);
			} else {
				this.modelId = id;
				this.getReceiptFromProductionCaseSource(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
